import React from "react";
import SaveButton, { SaveButtonProps } from "../Buttons/SaveButton";
import Popup from "./Popup";
import { StringWithFormat } from "../../types/Result";

interface IProps {
    title: string | StringWithFormat
    show: boolean
    onHide: () => void
    size?: 'sm' | 'lg' | 'xl';
    saveButtonProps: SaveButtonProps
    children?: React.ReactNode
}

const SavePopup: React.FC<IProps> = ({ title, show, onHide, size, saveButtonProps, children }) => {
    return (
        <Popup show={show} onHide={onHide} size={size} title={title}>
            <Popup.Body>
                {children}
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...saveButtonProps} />
            </Popup.Footer>
        </Popup>
    );
}
export default SavePopup;